import { formatShortScanDate } from '../formatScanDate';
import { getLatenessTone } from '../scanInstructionTone';
import { CIRCLE_Y, SELECTED_CIRCLE_SIZE } from './geometry';
import { MIN_INTERVAL_WIDTH, type TimelineInterval } from './scanScale';

/** Clearance so the connector starts outside whichever marker sits at each end. */
const MARKER_CLEARANCE = SELECTED_CIRCLE_SIZE / 2 + 3;

function describeInterval({ days, dueDate, uploadDate, lateDays }: TimelineInterval): string {
    const gap = `${days} days between scans`;
    if (lateDays == null) return `${gap} · no due date on the closing scan`;
    const verdict = lateDays > 0 ? `${lateDays}d late` : `${-lateDays}d early`;
    return `${gap} · due ${formatShortScanDate(dueDate ?? '')} · uploaded ${formatShortScanDate(
        uploadDate ?? ''
    )} · ${verdict}`;
}

function IntervalConnector({ interval }: { interval: TimelineInterval }) {
    const tone = getLatenessTone(interval.late, interval.lateDays);
    const from = interval.startX + MARKER_CLEARANCE;
    const width = interval.endX - MARKER_CLEARANCE - from;
    if (width <= 0) return null;

    return (
        <>
            <div
                aria-hidden
                className={`absolute -translate-y-1/2 rounded-full ${tone.line}`}
                style={{ top: CIRCLE_Y, left: from, width, height: 2 }}
            />
            {interval.endX - interval.startX >= MIN_INTERVAL_WIDTH && (
                <span
                    aria-hidden
                    className={`absolute -translate-x-1/2 -translate-y-1/2 whitespace-nowrap bg-white px-1 text-[10px] font-semibold leading-none tabular-nums ${tone.text}`}
                    style={{ top: CIRCLE_Y, left: (interval.startX + interval.endX) / 2 }}
                    title={describeInterval(interval)}
                >
                    {interval.days}d
                </span>
            )}
        </>
    );
}

export { IntervalConnector };
